import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogBody, DialogFooter, DialogTitle } from '../../../../components/ui/Dialog';
import Button from '../../../../components/ui/Button';
import AttachmentInputForm from './AttachmentInputForm';
import { UserAttachmentInput } from '../../../../models/general';
import { useTranslation } from 'react-i18next';

interface Props {
  open: boolean;
  onClose: () => void;
  onSave: () => void;
  attachmentInput: UserAttachmentInput;
  setAttachmentInput: React.Dispatch<React.SetStateAction<UserAttachmentInput>>;
  loading: boolean;
  title: string;
}

const AttachmentDialog: React.FC<Props> = ({ open, onClose, onSave, attachmentInput, setAttachmentInput, loading, title }) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onOpenChange={(isOpen) => { if (!isOpen) onClose(); }}>
      <DialogContent size="sm">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <DialogBody>
          <AttachmentInputForm
            attachmentInput={attachmentInput}
            setAttachmentInput={setAttachmentInput}
          />
        </DialogBody>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>{t("Cancel")}</Button>
          <Button loading={loading} onClick={onSave}>{t("Save")}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default AttachmentDialog;
